export const SectionHeader = ({ eyebrow, title, desc, align = "left" }) => {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className="text-xs sm:text-sm uppercase tracking-[0.22em] font-bold text-[#00B37E]">
          {eyebrow}
        </div>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-[#0A192F] mt-3 leading-[1.05]">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-base sm:text-lg text-[#475569] leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
